import {
  IPerformanceQueryParameters,
  ICustomerActivity,
  IPerformancePagination,
  IChartResult
} from '@/models/performance';
import APIService from '.';

export default class PerformanceActivitiesService extends APIService {
  getActivitiesOverview(resource: string, params: Record<string, any> = {}) {
    return this.get(resource, {
      params
    });
  }

  getActivitiesList(
    resource: string,
    filters: Omit<IPerformanceQueryParameters, 'shortcut'> = {}
  ) {
    return this.get<IPerformancePagination<ICustomerActivity>>(resource, {
      params: filters
    });
  }

  getCustomerTotalSpend() {
    return this.get('/v2/admin/business/overview/spend');
  }

  getCustomerSpend(filters: IPerformanceQueryParameters = {}) {
    return this.get<IChartResult>('/v2/admin/customer/growth/spend', {
      params: filters
    });
  }
}
